import dashboard from './dashboard';
import pages from './pages';
import utilities from './utilities';
import other from './other';

import manager from './manager';
import configuration from './configuration';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, manager, configuration, pages, utilities, other],
};

export default menuItems;
